import React from 'react';
import Style from '../Styles/LoginPaperStyle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import RecoverPasswordScreen from './RecoverPasswordScreen';
import settings from '../../../Settings/Settings'

export default function LoginPaper(props) {
  const classes = Style();

    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

    const componentProps = {
        ...props.componentProps
    }
    const [logInUsersEmail, setLogInUsersEmail] = React.useState('')
    const [logInUsersPassword, setLogInUsersPassword] = React.useState('')

    const logInAction = () => {
        componentMethods.setManagerState({loadingLogin: true})
        let requestLogInObject = {
            usersEmail: logInUsersEmail,
            usersPassword:logInUsersPassword,
        }
        componentMethods.ajax(settings.API_URL + settings.API_ENDPOINT_LOGIN,requestLogInObject,'POST',null, (data) => {
            componentMethods.setSuccessfulUsersLogIn(data); 
            componentMethods.clearLogInForm(); 
            componentMethods.getUserAddresses()
        }, {}, false, (data) => {
            componentMethods.setLogInErrors(data)}, () => {
            componentMethods.setManagerState({loadingLogin: false})
            componentMethods.addError(componentMethods.getManagerState().language['LANG_ERROR_ON_LOGIN'])
        })
    }

    if(componentMethods.getManagerState().recoverPasswordScreen) {
        return <RecoverPasswordScreen componentConstants={componentConstants} componentMethods={componentMethods} componentProps={componentProps} />
    }
  return (
    <form style={classes.root} noValidate autoComplete="off">
        <Typography variant="h5" component="h5" style={classes.title}>
            {componentConstants.language.LANG_AUTHENTICATE}
        </Typography>
        <TextField value={logInUsersEmail} error={componentMethods.getManagerState().formInvalidLogInUsersEmail} style={classes.formFullWidth} onChange={(event) => {setLogInUsersEmail(event.target.value)}} id="CREATE_ACCOUNT_EMAIL" label={componentConstants.language.LANG_EMAIL} fullWidth={true} />
        <TextField value={logInUsersPassword} type="password" error={componentMethods.getManagerState().formInvalidLogInPassword} style={classes.formFullWidth} onChange={(event) => {setLogInUsersPassword(event.target.value)}} id="CREATE_ACCOUNT_PASSWORD" label={componentConstants.language.LANG_PASSWORD} fullWidth={true} />
        {componentMethods.getManagerState().loadingLogin ?
            <CircularProgress />
        :
            <React.Fragment>
                <Button onClick={logInAction} variant="contained" disableElevation color="secondary" fullWidth={true} style={classes.closeButton}>
                    {componentConstants.language.LANG_AUTHENTICATE}
                </Button> 
                <Button disabled={componentMethods.getManagerState().loadingLogin} onClick={componentMethods.showRecoverPasswordScreen} variant="contained" color="primary" fullWidth={true} style={classes.closeButton}>
                    {componentConstants.language.LANG_RECOVER_PASSWORD}
                </Button>
            </React.Fragment>
        }
    </form>
  );
}